<template>
    <div>
        <Table
            ref="tableRef"
            :table="table"
            @selectRow="selectRow"
            @selectAllRow="selectAllRow"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button v-permission="'setting.sysSetting.assignRole'" type="primary" size="small" @click="handle('assignRole')">{{ $t('setting.assignRole') }}</a-button>
                <a-input-search 
                    :style="{background:'#fff',marginLeft:'20px',width:'320px',height:'30px'}" 
                    v-model="user_name" 
                    allow-clear 
                    @press-enter="pressEnter" 
                    @search="search" 
                    @clear="pressEnter"
                    :placeholder="t('base.enterUser')" 
                />
            </template>

            <!-- 自定义字段 -->
            <template v-slot:btnAuth="{ props }">
                <span v-if="props.record.role !== '-'">
                    <a-tag 
                        style="margin-right:10px"
                        v-for="(item,index) in props.record.role"
                        :key="index"
                        :color="item.color"
                        closable
                        :default-checked="true"
                        @close="handle('delRole', props.record, item)"
                    >{{ item.name }}</a-tag>
                </span>
                <span v-else>{{ props.record.role }}</span>
            </template>
        </Table>

        <!-- 新增按钮 -->
        <a-modal 
            class="addBtn"
            v-model:visible="visible"
            width="55%"
            draggable
            :render-to-body="false"
            :onBeforeOk="onSaveBeforeOk"
            @ok="handleSave"
        >
            <template #title>{{ $t('setting.assignRole') }}</template>
            <Form class="userForm" :form="userForm" @handleSelectChange="handleSelectChange"></Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { RoleApi } from '@/api/RoleApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { UserForm } from './queryConfig/SettingForm.js';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()
    const userForm = reactive(UserForm)
    const visible = ref(false)
    const user_name = ref('')
    const roleObj = ref({})
    const tableRef = ref(null)
    const table = ref({
        datas:[],
        columns:[
            {
                title:t('setting.user'), // 用户
                dataIndex: 'user_name',
                key:'user_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('setting.email'), // 邮箱
                dataIndex: 'email',
                key:'email',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('setting.role'), // 角色
                dataIndex: 'role',
                key:'role',
                align:'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            selected:[],
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getUserList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getUserList()
    }

    const handle = (type,row,item)=>{
        switch(type){
            case 'assignRole':
                if(table.value.configs.selected.length == 0){
                    Message.error(t('setting.assignUserMsg'))
                    return
                }

                visible.value = true
                userForm.formField.forEach(i=>{
                    userForm.formData[i.key] = ''
                })
                break;
            case 'delRole':
                // console.log(row,item,'row')
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        delUserRole(row,item)
                    },
                    onCancel:()=>{
                        window.location.reload()
                    }
                });
                break;
        }
    }  
    
    const getRoleName = (roleId)=>{
        let str = roleId.map(i=>{
            return {
                name:roleObj.value[i],
                color:i == 1? 'red' : i==2? 'green' : 'arcoblue',
                roleId: i,
            }
        })
        return str
    }

    const selectRow = (data)=>{
        table.value.configs.selected = data
    }

    const selectAllRow = (data)=>{
        table.value.configs.selected = data
    }
    
    const onSaveBeforeOk = ()=>{
        if(!userForm.formData.role){
            Message.error(t('setting.assignRoleMsg'))
            return false
        }
        return true
    }

    const pressEnter = ()=>{
        table.value.configs.pagination.current = 1
        getUserList()
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        user_name.value = val
        getUserList()
    }

    // 获取角色
    const getRoleList = async ()=>{
        let res = await RoleApi.    getInstance().getRoleList()
        if(res){
            let item = userForm.formField.find(i=> i.key == 'role')
            item.options = []
            res.forEach(i=>{
                item.options.push({
                    label:i.role_name,
                    value:i.id
                })
                roleObj.value[i.id] = i.role_name
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取用户
    const getUserList = async ()=>{
        let param = {
            user_name: user_name.value
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await RoleApi.getInstance().getUserList(param,page_num,page_size)
        if(res.code == 0){
            res.data.records.forEach(i=>{
                i.role = i.role_ids.length == 0? '-' : getRoleName(i.role_ids.sort((a,b)=>{return a-b}))
            })
            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 保存设置
    const handleSave = async ()=>{
        let arr = table.value.configs.selected.map(i=>{
            return {
                user_id: i.id,
                role_id: userForm.formData.role
            } 
        })

        let res = await RoleApi.getInstance().userRole(arr[0])
        if(res.code == 0){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: t('setting.loginMsg2'),
                okText:t('base.ok'),
                onOk:()=>{
                    // window.location.reload()
                    visible.value = false
                    tableRef.value.selectedKeys = []
                    tableRef.value.selectedData = []
                    getUserList()
                }
            });
        }else{
            Message.error(res.msg)
        }
    }

    // 删除用户角色
    const delUserRole = async(row,item)=>{
        let res = await RoleApi.getInstance().delUserRole(item.roleId,row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: t('setting.loginMsg3'),
                okText:t('base.ok'),
                onOk:()=>{
                    // window.location.reload()
                    getUserList()
                }
            });
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(async ()=>{
        await getRoleList()
        getUserList()
    })
</script>

<style lang="less" scoped>
/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

.userForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-form-item-content{
        height: 37px;
        min-height: 37px;
    }

    /deep/ .arco-form > div{
        margin-left: 70px !important;
    }
}



</style>